import React from 'react';
import DashboardView from './DashboardView';

function Dashboard() {
  const props = {};
  return <DashboardView {...props} />;
}

export default Dashboard;
